import React, { Fragment } from "react";
export default () => (
  <Fragment>
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div>
      <img
        // src={spinner}
        style={{ width: "200px", margin: "auto", display: "block" }}
      />
    </div>
  </Fragment>
);
